<template>
  <button type="button" class="modal-close" @click="$emit('click')">
    &times;
  </button>
</template>

<script>
export default {
  emits: ['click']
}
</script>

<style lang="scss" scoped>
@use "~common_styles/breakpoints" as breakpoints;

.modal-close {
  @include breakpoints.screen-mobile-only {
    display: none;
  }

  @include breakpoints.screen-md-up {
    position: fixed;
    border: none;
    background-color: unset;
    color: white;
    opacity: 0.5;
    top: 23px;
    right: 23px;
    font-size: 44px;
    line-height: 30px;
    width: 30px;
    padding: 0;
  }
}
</style>
